module.exports = __webpack_public_path__ + "static/media/cookie.64be484b.png";